import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDCircularLoader from "components/MDCircularLoader";
import BillingInformation from "./components/BillingInformation";
import TopUpPackages from "./components/TopUpPackages";
import { useQuery } from "@apollo/client";
import { toast } from "react-toastify";
import { IGetUserWallet, GET_USER_WALLET } from "graphql/queries/getUserWallet";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageShell from "components/common/PageShell";

function MyCredits(): JSX.Element {
  const { data, loading } = useQuery<IGetUserWallet>(GET_USER_WALLET, {
    fetchPolicy: "network-only",
    onError: (err) => toast.error(err?.message || "Failed to load wallet"),
  });

  return (
    <>
    {loading && <MDCircularLoader overlayloader startLoader />}
    <DashboardNavbar />
    <PageShell>
      <MDBox mb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={5}>
            <BillingInformation data={data} />
          </Grid>
          <Grid item xs={12} md={7}>
            <TopUpPackages />
          </Grid>
        </Grid>
      </MDBox>
    </PageShell>
    </>

  );
}

export default MyCredits;
